import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';

export const useGetGuestDetails = (guestUids: string[]) => {
  const token = useUserStore(state => state.token);
  
  return useQuery(
    ['guestDetails', guestUids],
    async () => {
      if (!guestUids || guestUids.length === 0) {
        return [];
      }

      const guestPromises = guestUids.map(async (uid) => {
        const response = await fetch(`${BASE_API_URL}users/${uid}`, {
          method: 'GET',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch user details for ${uid}`);
        }

        return await response.json();
      });

      return await Promise.all(guestPromises);
    },
    {
      enabled: !!guestUids && guestUids.length > 0 && !!token,
    }
  );
};